/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How ties are broken in leaderboard
 * @export
 */
export const TiebreakerMethod = {
    HEAD_TO_HEAD: 'HEAD_TO_HEAD',
    GOAL_DIFFERENCE: 'GOAL_DIFFERENCE',
    GOALS_SCORED: 'GOALS_SCORED',
    RATING_DEVIATION: 'RATING_DEVIATION',
    RECENT_FORM: 'RECENT_FORM',
    ALPHABETICAL: 'ALPHABETICAL'
} as const;
export type TiebreakerMethod = typeof TiebreakerMethod[keyof typeof TiebreakerMethod];


export function instanceOfTiebreakerMethod(value: any): boolean {
    for (const key in TiebreakerMethod) {
        if (Object.prototype.hasOwnProperty.call(TiebreakerMethod, key)) {
            if (TiebreakerMethod[key as keyof typeof TiebreakerMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TiebreakerMethodFromJSON(json: any): TiebreakerMethod {
    return TiebreakerMethodFromJSONTyped(json, false);
}

export function TiebreakerMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): TiebreakerMethod {
    return json as TiebreakerMethod;
}

export function TiebreakerMethodToJSON(value?: TiebreakerMethod | null): any {
    return value as any;
}

export function TiebreakerMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): TiebreakerMethod {
    return value as TiebreakerMethod;
}

